// extracted by mini-css-extract-plugin
export default {"root":"_1Vi6CpYL","ordersButton":"_3uLMpr34","single":"_3q-7Es_M"};